import { Controller } from 'react-hook-form'
import { TextField } from '@material-ui/core'
import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'

const FormAutocomplete = params => {
  return (
    <Controller
      name={params.name}
      control={params.control}
      {...params}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => {
        return (
          <Autocomplete
            {...params}
            value={value}
            onChange={(event, value, reason, details) => {
              onChange(value)
              if (params.onChange) {
                params.onChange(event, value, reason, details)
              }
            }}
            renderInput={textParams => (
              <TextField
                {...textParams}
                label={params.label}
                helperText={
                  error
                    ? error.message
                      ? error.message
                      : error.type === 'required'
                      ? 'Ce champ est obligatoire'
                      : null
                    : null
                }
                error={!!error}
              />
            )}
          />
        )
      }}
    />
  )
}
export default FormAutocomplete
